<template>
    <HeadlessButton class="underline hover:text-gray-900">
        <slot />
    </HeadlessButton>
</template>
